import { useCallback, useRef, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { ChevronDownIcon } from '../../../../assets/svg/iconos';
import useClickOutside from '../../../../hooks/useClickOutside';

export const SelectProfesional = ({objServicio, dataChange, editMode, big = false, top = false, left = false}) => {
    const { profesionales } = useSelector(state => state.profesionales);

    const [selectText, setSelectText] = useState('');

    const popover = useRef();
    const [isOpen, toggle] = useState(false);

    useEffect(() => {
        if( objServicio?.profesionales ){
            let seleccionados = 0;
            let disponibles = 0;
            
            const profesionalesServicio = objServicio.profesionales.map(prof => 
                typeof prof === 'object' && prof._id ? prof._id.toString() : prof.toString()
            );
            
            profesionales.forEach( profesional => {
                if( !profesional.deleted ){
                    disponibles++;
                    const profesionalIdStr = profesional._id.toString();
                    if( profesionalesServicio.includes( profesionalIdStr ) ){
                        seleccionados++;
                    }
                }
            });
            if( seleccionados === 0 ){
                setSelectText( 'Ninguno' );
            } else if( disponibles > 0 && seleccionados === disponibles ){
                setSelectText( 'Todos' );
            } else {
                setSelectText( 'Varios' );
            }
        } else {
            setSelectText( 'Ninguno' );
        }
    }, [objServicio, profesionales]);
    

    const close = useCallback(() => toggle(false), []);
    useClickOutside(popover, close);

    const clickSelect = () => {
        if( editMode ){
            toggle( !isOpen );
        }
    }

    const clickProfesional = ( idProfesional ) => {
        if( editMode ){
            let newProfesionales = [];
            const currentProfesionales = objServicio.profesionales || [];
            
            const idProfesionalStr = idProfesional.toString();
            const profesionalesStr = currentProfesionales.map(prof => 
                typeof prof === 'object' && prof._id ? prof._id.toString() : prof.toString()
            );
            
            if( profesionalesStr.includes( idProfesionalStr ) ){
                newProfesionales = currentProfesionales.filter( prof => {
                    const profStr = typeof prof === 'object' && prof._id ? prof._id.toString() : prof.toString();
                    return profStr !== idProfesionalStr;
                });
            } else {
                newProfesionales = [
                    ...currentProfesionales,
                    idProfesional
                ]
            }
            dataChange('profesionales', newProfesionales );
        }
    }

    return (
        <div 
            className='ylm-sucursal-select'
        >
            <div 
                className='select-main'
                onClick={ clickSelect }
            >
                <p>{ selectText }</p>
                <ChevronDownIcon color={ '#000000' }/>
            </div>
            {
                isOpen &&
                <ul
                    className={`select-options std-ul ${big && 'big'} ${top && 'top'} ${left && 'left'}`}
                    ref={popover}
                >
                    {
                        profesionales.map( profesional => {
                            if( profesional.deleted ) return null;
                            
                            const profesionalesServicio = objServicio?.profesionales?.map(prof => 
                                typeof prof === 'object' && prof._id ? prof._id.toString() : prof.toString()
                            ) || [];
                            const profesionalIdStr = profesional._id.toString();
                            const isSelected = profesionalesServicio.includes( profesionalIdStr );
                            
                            return (
                                <li
                                    key={ profesional._id }
                                    className={`std-li ${isSelected ? 'active' : ''}`}
                                    onClick={ () => clickProfesional( profesional._id )}
                                >
                                    <div className='checkbox-bg'>
                                        <span className='checkbox-item'></span>
                                    </div>
                                    <p>{ profesional.nombre }</p>
                                </li>
                            );
                        })
                    }
                </ul>
            }
        </div>
    )
}
